import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { IPackagingItemUsageListItem } from 'src/types/packaging-item-usage';

import axios from '../../utils/axios';

interface IInitialState {
  status: 'idle' | 'loading' | 'success' | 'failure';
  error: string | undefined;
  usageReport: {
    count: number;
    page: number;
    pageSize: number;
    pageCount: number;
    date: string | null;
    items: IPackagingItemUsageListItem[];
  };
}

const initialState: IInitialState = {
  status: 'idle',
  error: undefined,
  usageReport: {
    count: 0,
    page: 0,
    pageSize: 0,
    pageCount: 0,
    date: null,
    items: [],
  },
};

const packagingItemUsageSlice = createSlice({
  name: 'packagingItemUsage',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPackagingItemUsageReport.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getPackagingItemUsageReport.fulfilled, (state, action) => {
        state.status = 'success';
        state.usageReport = action.payload;
        state.error = initialState.error;
      })
      .addCase(getPackagingItemUsageReport.rejected, (state, action) => {
        state.usageReport = initialState.usageReport;
        state.status = 'failure';
        state.error = action.error.message;
      });
  },
});

export default packagingItemUsageSlice.reducer;

export const getPackagingItemUsageReport = createAsyncThunk(
  'packagingItemUsage/paginated',
  async (params: {
    date: Date;
    page: number;
    limit: number;
    generalSearch?: string | null;
    sortBy?: string | null;
    sort?: 'asc' | 'desc' | null;
  }) => {
    const { date, page, limit, generalSearch, sortBy, sort } = params;

    try {
      const response = await axios.get(
        `packaging/item/usage-report?date=${date.toISOString()}&page=${
          page + 1
        }&limit=${limit}&generalSearch=${generalSearch ?? ''}&sortBy=${
          sortBy ?? ''
        }&sort=${sort ?? ''}`
      );

      return response.data.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  }
);
